"use client";

import { createContext, useContext, type ReactNode } from "react";

import type { ExperimentResult, Variant } from "./bucket";

type ExperimentContextValue = {
  visitorId: string | undefined;
  experiments: ExperimentResult[];
};

const ExperimentContext = createContext<ExperimentContextValue | undefined>(
  undefined
);

export function ExperimentProvider({
  visitorId,
  experiments,
  children,
}: {
  visitorId: string | undefined;
  experiments: ExperimentResult[];
  children: ReactNode;
}) {
  return (
    <ExperimentContext.Provider value={{ visitorId, experiments }}>
      {children}
    </ExperimentContext.Provider>
  );
}

// consumer固有の実験ID一覧をこのパッケージは持てないため string で受ける。
// consumer側で型安全にしたい場合は薄いラッパーhookを自前で書く想定
export function useExperimentVariant(experimentId: string): Variant {
  const context = useContext(ExperimentContext);
  return (
    context?.experiments.find((e) => e.id === experimentId)?.variant ??
    "control"
  );
}

export function useExperiments(): ExperimentResult[] {
  return useContext(ExperimentContext)?.experiments ?? [];
}

export function useVisitorId(): string | undefined {
  return useContext(ExperimentContext)?.visitorId;
}
